<template>
  <div>
    <h2 class="step-name">Animal Numbers</h2>

    <div class="step-section">
      <div class="clearfix" :style="{ width: 400 + widthForRow(FARMS) + 'px' }">
        <div v-for="farm in FARMS" class="farm-fields" :key="farm.id">
          <h3>{{ farm.farm_label }}</h3>

          <number-input label="Total Cows Wintered" :farm-id="farm.id" field-name="cows_wintered_incl_r2" disabled>
          </number-input>

          <number-input label="PM Cows Pred." :farm-id="farm.id" field-name="cows_pm_predicted" disabled>
          </number-input>

          <number-input
            label="PM Cows confirmed (Nov)."
            :farm-id="farm.id"
            field-name="cows_pm_confirmed"
						ref="cows_confirmed"
            @on-change="
              setPmDiff(farm.id)
            "
          >
          </number-input>

          <number-input label="Diff" :farm-id="farm.id" field-name="cows_pm_diff" disabled> </number-input>

          <number-input
            label="How many heifers to be mated in November?"
            :farm-id="farm.id"
            field-name="heifers_to_be_mated_nov"
          >
          </number-input>
        </div>
      </div>

      <div v-if="!isReadOnly">
        <button @click="saveAndRedirectHome" type="button" class="btn btn-primary" :disabled="syncing">
          Save and Continue
        </button>

        <loader v-if="syncing"></loader>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import baseComponent from '@/mixins/base_consult_component_v2'

export default {
  name: 'AnimalNumbers',
  mixins: [baseComponent],
  data() {
    return {
      syncing: false,
    }
  },
	mounted() {
		(this.$refs.cows_confirmed[0] || this.$refs.cows_confirmed).$refs.numberinput.focus()
	},
  computed: {
    ...mapGetters('connection', ['online']),
  },
  methods: {
    ...mapActions('springConsult', ['saveConsultData', 'deleteSchema']),
    saveAndRedirectHome: function () {
      let now = new Date().toJSON()
      this.setFieldValue({
        fieldName: 'signed_at',
        modelName: this.$options.name,
        value: now,
      })

      this.onSubmit()
      this.$store.dispatch('alert/success', {
        message: 'Data has been saved locally',
        persist: true,
      })
      this.$router.push('/')
    },

    setPmDiff: function (farmId) {
      var total =
        (this.getFieldValue(this.prefixedField('cows_wintered_incl_r2', farmId)) || 0) -
        (this.getFieldValue(this.prefixedField('cows_pm_confirmed', farmId)) || 0)

      this.setFieldValue({
        fieldName: this.prefixedField('cows_pm_diff', farmId),
        modelName: this.$options.name,
        value: total,
      })
    },
  },
}
</script>

<style>
.farm-fields {
  float: left;
  width: 350px;
  margin-right: 3em;
}
</style>
